<template>
  <div
    class="quiz-results-card"
    :style="currentPageBgColor"
    @click="$emit('onClick')"
  >
    <div
      class="quiz-results-card-label"
      :style="{ color: isCurrentPage ? '#ffffff' : '#808080' }"
    >
      {{ label }}
    </div>
    <div class="quiz-results-card-icon">
      <img
        :src="require(`@/assets/images/${quizResultsIcon}`)"
        alt="icon"
        width="19px"
        height="19px"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'quiz-results-card',

  props: {
    isCorrect: {
      type: Boolean,
      default: false,
    },
    isCurrentPage: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },

  computed: {
    quizResultsIcon() {
      if (this.isCorrect) {
        if (this.isCurrentPage) {
          return 'ic_o_s_fo.svg';
        }

        return 'ic_o_s.svg';
      }

      if (this.isCurrentPage) {
        return 'ic_x_s_fo.svg';
      }

      return 'ic_x_s.svg';
    },

    currentPageBgColor() {
      if (!this.isCurrentPage) {
        return {};
      }

      if (this.isCorrect) {
        return {
          background: '#03a9f4',
        };
      }

      if (!this.isCorrect) {
        return {
          background: '#ff595f',
        };
      }

      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
  .quiz-results-card {
    display: inline-block;
    text-align: center;
    width: 10%;
    height: 54px;
    padding: 4px 0 8px 0;
    border-right: 1px solid #f0f0f0;
    border-bottom: 1px solid #f0f0f0;
    background: #ffffff;
    cursor: pointer;

    .quiz-results-card-label {
      font-size: 12px;
      font-weight: bold;
      color: #000000;
    }

    .quiz-results-card-icon {
      width: 19px;
      height: 19px;
      margin: 0 auto;
    }
  }
</style>
